import { render, staticRenderFns } from "./StageQuestions.vue?vue&type=template&id=e828632a"
import script from "./StageQuestions.vue?vue&type=script&lang=js"
export * from "./StageQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports